import React, { useContext, useState } from 'react';

import { excApi, handleApiCall } from '@exchange-frontends/api';
import { useIsMounted } from '@exchange-frontends/custom-hooks';

import { useStore } from '../../../store';
import { UserDataContext } from '../../App';
import AcquireAppButton from './AcquireAppButton';
import { FastSpringForm } from './FastSpringForm';

const CcPaidAppButton = () => {
  const { accessToken, profile } = useContext(UserDataContext) ?? {};
  const isMounted = useIsMounted();
  const [fastSpringId, setFastSpringId] = useState('');
  const detailScreen = useStore((state) => state.detailScreen);
  const appId = detailScreen?.id;
  const versionId = detailScreen?.appVersionId;
  const appType = detailScreen?.appType;

  const generateFastSpringId = async () => {
    if (accessToken) {
      const region = profile?.countryCode;
      const email = encodeURIComponent(profile?.email);
      const handler = handleApiCall(excApi.generateUniqueId, {
        appId,
        versionId,
        region,
        appType,
        email,
        accessToken,
      });
      const response = await handler.run();
      if (isMounted.current) {
        if (response.error) {
          console.error('response.error', response.error);
        } else {
          setFastSpringId(response);
        }
      }
    }
  };

  return (
    <>
      <AcquireAppButton type="paid" onPress={generateFastSpringId} />
      {profile && <FastSpringForm buyUrl={detailScreen?.pricingInfo?.buyUrl} fastSpringId={fastSpringId} />}
    </>
  );
};

export default CcPaidAppButton;
